import React, { useState, useEffect } from "react";
import { FaEye } from "react-icons/fa";
import QRCode from "qrcode.react"; // Import QR code library
import { IoIosRefresh } from "react-icons/io";
import { saveAs } from "file-saver";
import { ImCross } from "react-icons/im";
import { GoDownload } from "react-icons/go";
import dayjs from "dayjs";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal"; // Import react-modal for handling modals
import { toast } from "react-toastify";
import LoadingSpinner from "../components/LoadingSpinner";
import TopUp from "./Topup"; // Import the Plan component
import { IoMdSearch } from "react-icons/io";
import { FaEdit } from "react-icons/fa";
import { FaCheck } from "react-icons/fa"; // Add this import for checkmark icon
import { FaUserPen } from "react-icons/fa6";

const PurchaseReport = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [filter, setFilter] = useState(""); // State to manage dropdown filter
  const apiUrl = process.env.REACT_APP_BASE_URL; // Use the environment variable
  const [userRole, setUserRole] = useState(null); // State for user role
  const navigate = useNavigate();
  const [modalIsOpen, setModalIsOpen] = useState(false); // State for modal visibility
  const [renewalConfirmation, setRenewalConfirmation] = useState(null); // To store renewal confirmation message

//For renewal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [renewalTime, setRenewalTime] = useState("");
  const [selectedSale, setSelectedSale] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // Add this line

const [showConfirmationModal, setShowConfirmationModal] = useState(false);
const [pendingRenewal, setPendingRenewal] = useState(null); // { plan, month }
 // NEW: States for inline editing Partner Customer
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [editValue, setEditValue] = useState("");

  const [fromDate, setFromDate] = useState(
    dayjs().subtract(1, "month").toDate()
  );
  const [toDate, setToDate] = useState(dayjs().toDate());
const [newExpiryDate, setNewExpiryDate] = useState(null);
// Usage example within React component
// Updated useEffect with better logging
// Updated useEffect with better logging and multiple order ID fields
useEffect(() => {
  // Try different possible order ID fields
  const orderId = selectedPlan?.orderid || selectedPlan?.order_id;
  
  if (orderId) {
    console.log('🔄 useEffect triggered for order ID:', orderId);
    console.log('📝 Selected plan object:', selectedPlan);
    
    fetchRenewalData(orderId).then(newExpiryDate => {
      console.log('🎯 fetchRenewalData completed with result:', newExpiryDate);
      
      if (newExpiryDate) {
        setNewExpiryDate(newExpiryDate);
        console.log('✅ newExpiryDate state updated to:', newExpiryDate);
        
        // Also log the formatted version
        const formattedDate = dayjs(newExpiryDate).format('DD-MM-YYYY HH:mm:ss');
        console.log('📅 Formatted newExpiryDate:', formattedDate);
      } else {
        console.log('❌ No new expiry date found or API call failed');
        setNewExpiryDate(null);
      }
    });
  } else {
    console.log('⏸️ No order ID available in selectedPlan');
    console.log('🔍 Available fields in selectedPlan:', Object.keys(selectedPlan || {}));
  }
}, [selectedPlan]);



const fetchAndExportData = async () => {
  try {
    setLoading(true);

    const token = localStorage.getItem("token");
    const partnerCode = localStorage.getItem("partnerCode");

    if (!token) {
      toast.error("No token found. Please log in.");
      setLoading(false);
      return;
    }

    const payload = {
      flag: 4,
      fromdate: fromDate,
      todate: toDate,
      partnerCode: partnerCode,
    };

    console.log("Payload being sent to the API:", payload);

    const url = `${apiUrl}ESIM/Get_purchasereport_sourcewise`;

    const response = await axios.get(url, {
      params: payload,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = response.data.partnersale;

    if (!Array.isArray(data) || data.length === 0) {
      toast.error("No data found for the selected date range.");
      setLoading(false);
      return;
    }

    // Format activationCode for each item
    const formattedData = data.map((item) => {
      const activationCodeRaw = item.activationCode || "";
      let activationCodeAndroid = activationCodeRaw;
      let smdpIOS = "";
      let activationCodeIOS = "";

      if (activationCodeRaw.startsWith("LPA:1$")) {
        const parts = activationCodeRaw.split("$");
        if (parts.length === 3) {
          smdpIOS = parts[1];
          activationCodeIOS = parts[2];
        }
      }

      return {
        ...item,
        activationCodeAndroid,
        smdpIOS,
        activationCodeIOS,
      };
    });

    // Build CSV headers and rows
    const headers = Object.keys(formattedData[0]).join(",");
    const rows = formattedData
      .map((row) => Object.values(row).map((value) => `"${value}"`).join(","))
      .join("\n");

    const csvContent = headers + "\n" + rows;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const fileName = `PurchaseReport_${fromDate}_${toDate}.csv`;

    saveAs(blob, fileName);

    setLoading(false);
  } catch (error) {
    console.error("Error fetching or exporting data:", error);
    setLoading(false);
  }
};


  const handleCreateTicket = async () => {
    const token = localStorage.getItem("token"); // Get token from localStorage
    const partnerCode = localStorage.getItem("partnerCode"); // Get partnercode from localStorage
       const ticketData = {
    iccid: selectedPlan?.order_id || "", // Use the actual order ID from the selected plan
    descrition: "I want to return this plan",
      partnercode: partnerCode,
      issuedepartment: 3,
      amount: 0,
    };

    try {
      const response = await axios.post(
        `${apiUrl}ESIM/CreateTicket`,
        ticketData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        // Check for successful response status
        toast(
          "Ticket raised successfully! Our team will get back to you soon."
        );
        // Navigate to YourTicket page upon success
        navigate("/YourTicket");
        console.log("Ticket Created:", response.data);
      } else {
        console.error("Unexpected response status:", response.status);
      }
    } catch (error) {
      console.error("Error creating ticket:", error);
      toast.error("Error creating ticket. Please try again.");
    }
  };

  useEffect(() => {
    // Fetch user role from localStorage
    const role = localStorage.getItem("role");
    setUserRole(role);
  }, []);
  useEffect(() => {
    const fetchReportData = async () => {
      try {
        const token = localStorage.getItem("token");
        const partnerCode = localStorage.getItem("partnerCode");
        const response = await fetch(
          `${apiUrl}ESIM/Get_purchasereport_sourcewise?flag=3&partnercode=${partnerCode}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();

        if (data.isSuccess) {
          setReportData(data.partnersale);
        } else {
          setError(data.message);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, []);

  const openModal = (plan) => {
    setSelectedPlan(plan);
    setQrModalOpen(true);
  };

 const closeModal = () => {
  // Close both modals (Top Up & Subscription Renewal)
  setModalIsOpen(false); // Close the Top Up modal
  setIsModalOpen(false);  // Close the Subscription modal
  setSelectedPlan(null);   // Reset selected plan
  setRenewalTime("");     // Reset renewal time input
  setRenewalConfirmation(null); // Reset confirmation message
};


 const handleTopup = (plan) => {
  localStorage.setItem("guid", plan.guid);
  localStorage.setItem("planid", plan.planid);
  localStorage.setItem("Iccid", plan.iccid);
  localStorage.setItem("vendorid", plan.supplier);
  setSelectedPlan(plan);  // Fix this line
  
  // Open the appropriate modal based on the supplier
  if (plan.recharge === "1") {
    setIsModalOpen(true); // For Subscription
  } else {
    setModalIsOpen(true); // For Top Up
  }
};
  // Function to handle renewal logic
 
  const handleDownload = (lpacode) => {
    // Simulate downloading logic here
    // For demonstration purposes, download a dummy QR code image
    const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?data=${lpacode}&size=200x200`;
    saveAs(qrCodeUrl, `QR_${lpacode}.png`);
  };



  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  // Modify your filteredReportData to include search functionality
  const filteredReportData = (filter ? reportData.filter((sale) => sale.saletype === filter) : reportData)
    .filter(sale => {
      if (!searchQuery) return true;
      
      const query = searchQuery.toLowerCase();
      return (
        sale.order_id?.toLowerCase().includes(query) ||
        sale.planname?.toLowerCase().includes(query) ||
        sale.iccid?.toLowerCase().includes(query)
      );
    });

  if (error) {
    return <p>Error: {error}</p>;
  }
  const handleViewDetails = (item) => {
    // Prepare details for the API payload
    const details = {
      flag: 0,
      dataUsed: item.dataUsed,
      plan_Source: item.plan_source,
      dataallowance: item.dataallowanceMB,
      orderNumber: item.order_id,
      inventoryid: item.inventoryid,
      lpa: item.activationCode,
      dollar: item.dollar,
      price: item.purchaseamount,
      iccid: item.iccid,
      sellingamount: item.selling_price,
      subscriberID: item.subscriberID,
      cli: item.cli,
      purchasedate: "string",
      supplier: item.supplier,
      rc_id: 0,
      pagesno: 0,
      planid: "string",
      operatorid: "string",
      apn: "string",
      planfor: "string",
      planname: "string",
      esimNetProdcutCode: "string",
      internetdata: "string",
      dataunit: "string",
      validity: "string",
      validitytype: "string",
      minutes: "string",
      country: "string",
      region: "string",
      type: "string",
      travellertype: "string",
      dataallowancetype: "string",
      dataallowanceMonthly: "string",
      fairusagespolicy: "string",
      remarks: "string",
      buyingcost: "string",
      recharge: "string",
      topupname: "string",
      currency: "string",
      plancost: "string",
      priority: "string",
      userid: "string",
      roletype: "string",
      countryimage: "string",
      planimage: "string",
      planstatus: "string",
      addInfo: "string",
      ppartnerID: "string",
      minute: "string",
      plnclass: "string",
      fromdate: "string",
      todate: "string",
      topseler: "string",
      bestseler: "string",
      stockvalues: "string",
      internetbreakout: "string",
      internetbreakout_code: "string",
      order: 0,
      kyc: 0,
      operatortype: "string",
      minPlan: "string",
      perMBPrice: "string",
      throttle: "string",
      monthpluspln: "string",
      status: "string",
      operatorname: "string",
      operatorname2: "string",
      operatorlogo: "string",
      traveldates: "string",
      reference: "string",
      meta_title: "string",
      vendor_id: "string",
      activation_Date: "2025-03-17T09:38:25.021Z",
      activation_EndDate: "2025-03-17T09:38:25.021Z",
      email: "string",
      newICCID: "string",
      productCode: "string",
      paymentid: 0,
      kyc_type: "string",
      reason_Code: "string",
      esim_Status: "string",
      smdp: "string",
      cancelDate: "2025-03-17T09:38:25.021Z",
      subscrption_status: "string",
      dumyQRCode: "string",
      docStatus: 0,
      customerid: "string",
      guid: "string",
      travelDate: "2025-03-17T09:38:25.021Z",
      travelDateString: "string",
      buyingamount: "string",
      guidelineName: "string",
      guidelineId: 0,
      isDeleted: 0,
      durationType: 0,
      coverage: "string",
      esimPopResponce: "string",
      mcc: "string",
      mnc: "string",
      conditions: "string",
      features: "string",
      eventTypeID: "string",
      eventTypeName: "string",
      eventInfo: "string",
      isActive: "string",
      sdStatusID: "string",
      productID: "string",
      productName: "string",
      imei: "string",
      startDate: "string",
      createDate: "string",
      serviceDeviceID: "string",
      dataRemaining: 0,
      dataRemainingString: 0,
      imsi: "string",
      sms: 0,
      maxQty: 0,
      minQty: 0,
      bestValue: "string",
      gpAmt: 0,
      updateDate: "string",
      filePath: "string",
      ticketNumber: "string",
      simOperator: "string",
      tariff: 0,
      boltOns: 0,
    };

    //    console.log("Details sent in API request:", details);
    // toast.error("Details sent to API:\n\n" + JSON.stringify(details, null, 2));

    const token = localStorage.getItem("token");

    if (!token) {
      toast.error("Unauthorized: No token found.");
      return;
    }

    // Send the details to the API using fetch
    fetch(`${apiUrl}ESIM/Get_data_uasage`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json", // Set content type as JSON
        Authorization: `Bearer ${token}`, // Attach the token to the headers
      },
      body: JSON.stringify(details), // Convert the details object to a JSON string
    })
      .then((response) => response.json()) // Parse JSON response
      .then((data) => {
        console.log("API response:", data);
        if (data.isSuccess) {
          toast.error(`${data.message}`);
        } else {
          toast.error(`Error: ${data.message}`);
        }
      })
      .catch((error) => {
        console.error("Error posting data:", error);
        toast.error(error.message || "An error occurred while posting data.");
      });
  };


const requestRenewal = (plan, month) => {
  setPendingRenewal({ plan, month });
  setShowConfirmationModal(true);
};
const handleRenew = async () => {
  if (!pendingRenewal) return;

  const { plan, month } = pendingRenewal;
  const payload = {
    flag:"1",
    userAmount: (plan.purchaseamount * month).toString(),
    orderID: plan.order_id || "default-order-id",
    renewalDays: month * 30,
  };

  try {
    const response = await axios.post(`${apiUrl}Renew/InsertRenew`, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*'
      }
    });
  // ✅ Always show message from API
  alert(response.data?.message || 'No message from server.');

    closeModal();
  } catch (error) {
      const apiMessage = error.response?.data?.message;
  // alert(`Renewal failed: ${apiMessage || error.message}`);
    alert(`Renewal failed: ${error.response?.message || error.message}`);
  } finally {
    setLoading(false);
    setShowConfirmationModal(false);
    setPendingRenewal(null);
  }
};

const updatecustomer = async (partnerCustomer, orderId) => {
  try {
    const token = localStorage.getItem("token");
    const partnerCode = localStorage.getItem("partnerCode");
    const response = await axios.post(
      `${apiUrl}ESIMGOAdmin/UpdatePartnerCustomer`,
      {
        partnerCode: partnerCode,
        orderId: orderId,
        partnerCustomer: partnerCustomer
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
      if (response.data.isSuccess) {
        toast.success("Partner Customer updated successfully!");
        // Update local state to reflect the change
        setReportData(prevData =>
          prevData.map(sale =>
            sale.order_id === orderId
              ? { ...sale, partnerCustomer: partnerCustomer }
              : sale
          )
        );
        // Reset editing state
        setEditingOrderId(null);
        setEditValue("");
      } else {
        toast.error(response.data.message || "Failed to update Partner Customer");
      }
    } catch (error) {
      console.error("Error updating partner customer:", error);
      toast.error("Error updating Partner Customer. Please try again.");
    }
  };

  // NEW: Function to start editing
  const startEditing = (orderId, currentValue) => {
    setEditingOrderId(orderId);
    setEditValue(currentValue || "");
  };

  // NEW: Function to save edit
  const saveEdit = (orderId) => {
    if (editValue.trim() !== "") {
      updatecustomer(editValue, orderId);
    } else {
      toast.warning("Please enter a valid Partner Customer name");
    }
  };

  // NEW: Function to cancel edit
  const cancelEdit = () => {
    setEditingOrderId(null);
    setEditValue("");
  };



// Assuming selectedPlan.orderid contains the order ID to match
const fetchRenewalData = async (orderId) => {
  try {
    console.log(`🔍 Fetching renewal data for order ID: ${orderId}`);
    
    const partnerCode = localStorage.getItem("partnerCode");
    
    const payload = {
      partnerCode: partnerCode,
      pageSize: 5000,
      pageIndex: 1
    };

    console.log('📤 Sending POST request with payload:', payload);

    const response = await axios.post(
      `${apiUrl}Renew/GetRenewData`,
      payload,
      {
        headers: {
          'accept': '*/*',
          'Content-Type': 'application/json'
        }
      }
    );

    console.log('📦 Full API Response:', response.data);

    if (!response.data.isSuccess) {
      console.error('❌ API returned unsuccessful:', response.data.message);
      return null;
    }

    const renewalData = response.data.renewData || [];
    
    console.log(`📊 Total renewal records received: ${renewalData.length}`);
    console.log('📋 All order IDs in response:');
    renewalData.forEach((item, index) => {
      console.log(`   ${index + 1}. orderID: "${item.orderID}", newExpiryDate: "${item.newExpiryDate}"`);
    });

    // Find the matching renewal record by order ID (note: it's orderID, not originalOrderId)
    const matchedRenewal = renewalData.find(item => {
      const isMatch = item.orderID === orderId;
      console.log(`   Comparing: "${item.orderID}" === "${orderId}" -> ${isMatch}`);
      return isMatch;
    });

    if (matchedRenewal) {
      console.log('✅ MATCH FOUND!');
      console.log('🎯 Matched renewal record:', matchedRenewal);
      console.log('📅 New expiry date from API:', matchedRenewal.newExpiryDate);
      
      // Format and log the date in a readable format
      if (matchedRenewal.newExpiryDate) {
        const formattedDate = dayjs(matchedRenewal.newExpiryDate).format('DD-MM-YYYY HH:mm:ss');
        console.log('📅 Formatted new expiry date:', formattedDate);
      }
      
      return matchedRenewal.newExpiryDate;
    } else {
      console.log('❌ NO MATCH FOUND for order ID:', orderId);
      console.log('💡 Available order IDs:', renewalData.map(item => item.orderID));
      return null;
    }
  } catch (error) {
    console.error('🚨 Failed to fetch renewal data:', error);
    console.error('Error details:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    return null;
  }
};


  if (loading) {
    return (
      <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
        <LoadingSpinner />
      </div>
    );
  }
  return (
    <>
     <div className="flex flex-col md:flex-row md:justify-end mb-4 space-y-4 md:space-y-0 md:space-x-4">
  {/* Aligns everything to the right on desktop, stacks vertically on mobile */}
  <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 w-full md:w-auto">
    {/* Flex container for inputs with spacing, vertical on mobile */}
    <div className="w-full md:w-auto">
      <label className="block mb-2">From Date:</label>
      <input
        type="date"
        className="border-2 bg-[#3E436D] rounded-full p-2 pl-10 w-full md:w-96 text-[#d0e6e8] placeholder-[#aeb7b8]"
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
      />
    </div>
    <div className="w-full md:w-auto">
      <label className="block mb-2">To Date:</label>
      <input
        type="date"
        className="border-2 bg-[#3E436D] rounded-full p-2 pl-10 w-full md:w-96 text-[#d0e6e8] placeholder-[#aeb7b8]"
        value={toDate}
        onChange={(e) => setToDate(e.target.value)}
      />
    </div>
  </div>
  <button
    className="rounded-lg text-white font-semibold p-2 bg-[#3E436D] shadow-md hover:bg-[#aeb7b8] transition duration-200 ease-in h-10 mt-0 md:mt-8 w-full md:w-auto"
    
    onClick={fetchAndExportData}
    disabled={loading}
  >
    {loading ? "Generating..." : "Download CSV"}
  </button>
</div>

<div className="flex flex-col md:flex-row md:justify-between items-center p-2 bg-white space-y-4 md:space-y-0">
  <h2 className="text-3xl md:text-5xl font-bold w-full md:w-auto">Purchase History</h2>
  <div className="flex flex-col md:flex-row md:items-center w-full md:w-auto space-y-4 md:space-y-0 md:space-x-4">
    <div className="bg-[#3E436D] p-1 rounded-xl w-full md:w-96">
      <div className="relative">
        <input
          type="text"
          placeholder="Search Order ID Plan Name, ICCID"
          className="w-full rounded-2xl bg-[brand-gray] h-8 pl-10"
          value={searchQuery}
          onChange={handleSearch}
        />
        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
          <IoMdSearch size={20} className="text-gray-500" />
        </div>
      </div>
    </div>

    <label htmlFor="filter" className="text-xl md:text-5xl font-bold mr-0 md:mr-2">
      Sale Type:
    </label>
    <select
      id="filter"
      value={filter}
      onChange={(e) => setFilter(e.target.value)}
      className="px-4 py-2 text-center border border-gray-700 rounded-md"
    >
      <option value="">All</option>
      <option value="API">API</option>
      <option value="Portal">Portal</option>
    </select>
  </div>
</div>


      <table className="w-full bg-white rounded-md  ">
        <thead>
          <tr>
            {/* <th className="px-6 py-3 text-center">Plan Source</th> */}
            <th className="px-6 py-3 text-center">Order ID</th>
            <th className="px-6 py-3 text-center">Purchase Date</th>
            <th className="px-6 py-3 text-center">Plan Name</th>
            {userRole === "Partner" && (
              <th className="px-6 py-3 text-center">Purchase Amount</th>
            )}
            <th className="px-6 py-3 text-center">Data Usage</th>
            <th className="px-6 py-3 text-center">Sale Type</th>
            {/* <th className="px-6 py-3 text-center">supplier </th> */}
            <th className="px-6 py-3 text-center">Top Up/Renew</th>
            <th className="px-6 py-3 text-center">Actions</th>
            <th className="px-6 py-3 text-center">Tag Name</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {filteredReportData.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center py-4">
                <p className="text-lg font-bold">No Active Packages</p>
              </td>
            </tr>
          ) : (
            filteredReportData.map((sale, index) => (
              <tr key={index}>
                {/* <td className="px-6 py-4 text-center">{sale.plan_source}</td> */}
                <td className="px-6 py-4 text-center">{sale.order_id}</td>
                <td className="px-6 py-4 text-center">{sale.purchasedate}</td>
                <td className="px-6 py-4 text-center">{sale.planname}</td>
                {userRole === "Partner" && (
                  <td className="px-6 py-4 text-center">
                    ${parseFloat(sale.purchaseamount).toFixed(2)}
                  </td>
                )}
                <td className="px-6 py-4 flex text-center">
                  <button
                    onClick={() => handleViewDetails(sale)}
                    className="font-bold self-stretch shadow-[0px_2px_8px_rgba(92,_152,_140,_0.3)] rounded-xl bg-[#3E436D]  hover:bg-[#144745]  text-brand-white m-2 p-4"
                  >
                    {/* Reload Data */}
                    <IoIosRefresh />
                  </button>
                </td>
                <td className="px-6 py-4 text-center">{sale.saletype}</td>
                {/* <td className="px-6 py-4 text-center">{sale.supplier}</td> */}
                <td className="px-6 py-4 text-center">
                <button
                  onClick={() => handleTopup(sale)}
                  className={`font-bold rounded-3xl p-4 text-white ${
                    sale.recharge === "1" ? "text-[#3E436D] border-4  2px solid #3E436D" : "bg-[#3E436D]"
                  }`}
                >
                  {sale.recharge === "1" ? "Renew" : "Top_up"}
                </button>
              </td>

                <td className="px-6 py-4 flex text-center">
                  <button
                    className="text-black font-bold py-2 px-4 rounded space-x-2"
                    onClick={() => handleDownload(sale.activationCode)}
                  >
                    <GoDownload />
                  </button>
                  <button
                    className="text-black font-bold py-2 px-4 rounded space-x-2"
                    onClick={() => openModal(sale)}
                  >
                    <FaEye />
                  </button>
                </td>
               {/* UPDATED: Partner Customer cell with inline editing */}
                <td className="px-6 py-4 text-center">
                  {editingOrderId === sale.order_id ? (
                    <div className="flex items-center justify-center gap-2">
                      <input
                        type="text"
                        value={editValue}
                        onChange={(e) => setEditValue(e.target.value)}
                        className="border-2 border-[#117575] rounded-lg px-2 py-1 w-32 focus:outline-none focus:border-[#3E436D]"
                        autoFocus
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') saveEdit(sale.order_id);
                          if (e.key === 'Escape') cancelEdit();
                        }}
                        placeholder="Enter name"
                      />
                      <button
                        onClick={() => saveEdit(sale.order_id)}
                        className="text-green-600 hover:text-green-800 font-bold p-1 rounded transition-colors"
                        title="Save"
                      >
                        <FaCheck size={16} />
                      </button>
                      <button
                        onClick={cancelEdit}
                        className="text-red-600 hover:text-red-800 font-bold p-1 rounded transition-colors"
                        title="Cancel"
                      >
                        <ImCross size={14} />
                      </button>
                    </div>
                  ) : (
                  <div className="flex items-center justify-between gap-1 bg-[#f8fafc] rounded-xl border-2 border-[#ebeff5] p-2">
  <span className="text-[#90a1b9] max-w-[150px] sm:max-w-[120px] md:max-w-[100px] overflow-hidden text-ellipsis whitespace-nowrap">
    {sale.partnerCustomer || 'Edit Name'}
  </span>
  <button
    className="text-[#90a1b9] hover:text-[#3E436D] font-bold py-2 px-2 transition-colors text-shadow-lg ml-auto"
    onClick={() => startEditing(sale.order_id, sale.partnerCustomer)}
    title="Edit Partner Customer"
  >
    <FaUserPen size={16} />
  </button>
</div>

                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>




      {qrModalOpen && selectedPlan && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex items-center justify-center overflow-y-auto">
          <div className="bg-white p-8 rounded-md flex flex-row relative  mt-36 ">
            {/* Left column */}
            <div className="flex flex-col items-start w-96">
              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <span className="font-bold">Order ID:</span>{" "}
                <span className="ml-4">{selectedPlan?.order_id || "N/A"}</span>
              </div>
              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <span className="font-bold">APN:</span>{" "}
                <span className="ml-4">{selectedPlan?.apn || "N/A"}</span>
              </div>
              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <span className="font-bold">ICCID/MSISDN:</span>{" "}
                <span className="ml-4">{selectedPlan?.iccid || "N/A"}</span>
              </div>
              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <span className="font-bold">SIMPIN:</span>{" "}
                <span className="ml-4">{selectedPlan?.simpin || "N/A"}</span>
              </div>

              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <h1 className="font-bold">
                  For iOS Devices:
                  <span className="font-normal">
                    {" "}
                    Use Below SMDP & Activation code
                  </span>
                </h1>

                {(() => {
                  const fullCode = selectedPlan?.activationCode || "";
                  const parts = fullCode.split("$");
                  const smdp = parts.length >= 2 ? parts[1] : "N/A";
                  const activation = parts.length >= 3 ? parts[2] : "N/A";

                  return (
                    <div>
                      <div>
                        <span className="font-bold">SMDP:</span>
                        <span className="ml-4">{smdp}</span>
                      </div>
                      <div>
                        <span className="font-bold">Activation Code:</span>
                        <span className="ml-4">{activation}</span>
                      </div>
                    </div>
                  );
                })()}
              </div>
              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <h1 className="font-bold">For Andriod Devices: <span className="font-normal">Enter below Activation Code.</span> </h1>{" "}
                  {selectedPlan?.activationCode || "N/A"}
              </div>
              {/* <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                
                <span className="font-bold"> Activation Status:</span>{" "}
                <button
                  onClick={() => setIsActive(!isActive)}
                  className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors ${
                    isActive ? "bg-[#47a192]" : "bg-red-600"
                  }`}
                >
                  <span
                    className={`${
                      isActive ? "translate-x-6" : "translate-x-1"
                    } inline-block w-4 h-4 transform bg-white rounded-full transition-transform`}
                  ></span>
                </button>
                <span
                  className={`ml-2 text-lg ${
                    isActive ? "text-[#47a192]" : "text-gray-600"
                  }`}
                >
                  {isActive ? "Active" : "Inactive"}
                </span>
              </div> */}
              <div className="mb-4 p-2 w-full border-4 bg-slate-200 rounded-2xl">
                <div className="flex justify-between items-center mb-2">
                  <span className="font-semibold text-lg">Data usage:</span>
                  <div className="text-sm font-medium flex gap-2">
                    <span>
                      {selectedPlan?.dataUsed
                        ? `${Number(selectedPlan.dataUsed).toFixed(2)} MB`
                        : "N/A"}
                    </span>
                  </div>
                </div>
                <div className="flex justify-between items-center mb-2">
                  <span className="font-semibold text-lg">Data Remaining:</span>
                  <div className="text-sm font-medium flex gap-2">
                    <span>
                      {selectedPlan?.dataUsageRemaining
                        ? `${Number(selectedPlan.dataUsageRemaining).toFixed(
                            2
                          )} MB`
                        : "N/A"}
                    </span>
                  </div>
                </div>
                <div className="w-full bg-gray-300 rounded-full h-4">
                  <div
                    className="bg-[#47a192] h-4 rounded-full"
                    style={{
                      width: `${
                        selectedPlan?.dataUsed && selectedPlan?.dataallowanceMB
                          ? (selectedPlan.dataUsed /
                              selectedPlan.dataallowanceMB) *
                            100
                          : 0
                      }%`,
                    }}
                  ></div>
                </div>
              </div>

              <div className="mb-4 p-4 w-full border-4 bg-[#c5f1f1] rounded-2xl">
                <span className="font-bold">How to Install ?</span>
                <a
                  href="https://www.airhubapp.com/info/esim-installation"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-4 border-2 rounded-2xl hover:bg-blue-400 p-2 border-black"
                >
                  Step by Step Guide
                </a>
              </div>
            </div>

            {/* Right column */}
            <div className="flex flex-col items-center justify-center ml-8 hidden md:block ">
              <QRCode
                value={selectedPlan.activationCode}
                className="border-4 p-2 border-[#47a192]"
                size={200}
              />
              <button
                className="text-[#595959] flex items-center border border-black px-4 py-2 rounded mt-4"
                onClick={() => handleDownload(selectedPlan.activationCode)}
              >
                <GoDownload size={30} /> Download
              </button>
              <br></br>
              <button
                onClick={handleCreateTicket}
                className="self-stretch shadow-[0px_2px_8px_rgba(92,_152,_140,_0.3)] rounded-xl bg-brand-green-selected  hover:bg-[#144745] h-10 flex flex-row items-center justify-center p-2.5 box-border text-brand-white m-4"
              >
                Ticket For Dispute
              </button>
            </div>

            {/* Close button */}
            <ImCross
              size={30}
              onClick={closeModal}
              className="cursor-pointer absolute top-2 right-2"
            />
          </div>
        </div>
        
      )}





      {/* */}
   <Modal
  isOpen={modalIsOpen}
  onRequestClose={closeModal}
  style={{
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    content: {
      width: "80%",
      height: "90%",
      margin: "auto",
      padding: "0px",
      borderRadius: "8px",
    },
  }}
>
  <div className="absolute top-4 right-5 flex justify-center items-center">
    <button onClick={closeModal} className="text-black">
      <ImCross size={20} />
    </button>
  </div>
  {selectedPlan && <TopUp plan={selectedPlan} closeModal={closeModal} />}
</Modal>

{isModalOpen && selectedPlan && (
  <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
    <div className="bg-white p-6 rounded-lg w-11/12 md:w-2/3 h-5/6 relative shadow-lg flex flex-col">
      {/* Modal Title */}
      <h1 className="text-2xl md:text-3xl font-bold mb-4 text-center text-gray-900">
        Please select Order ID 
      </h1>

      {/* Close Button */}
      <button
        onClick={closeModal}
        className="absolute top-4 right-4 p-2 text-gray-600 hover:text-gray-800 transition"
      >
        <ImCross size={20} />
      </button>

      {/* Scrollable Content */}
     <div className="overflow-y-auto flex-1">
  {!renewalConfirmation ? (
    <table className="min-w-full table-auto mb-4 text-gray-700 border">
      <thead className="bg-gray-100 sticky top-0">
        <tr className="border-b">
          <th className="border px-4 py-2 text-center">Order ID</th>
          <th className="border px-4 py-2 text-center">Subscription Month</th>
          <th className="border px-4 py-2 text-center">Amount</th>
          <th className="border px-4 py-2 text-center">Purchase Date</th>
          <th className="border px-4 py-2 text-center">Current Expiry</th>
          <th className="border px-4 py-2 text-center">After Renewal Expiry</th>
          <th className="border px-4 py-2 text-center">New Expiry Date</th> {/* Dynamic column */}
          <th className="border px-4 py-2 text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        {[...Array(12)].map((_, i) => {
          const month = i + 1;
          const baseAmount = parseFloat(selectedPlan.purchaseamount) || 0;
  // Use the correct order ID field (order_id from your table data)
  const currentOrderId = selectedPlan.order_id;


  // Debug log for each row
  console.log(`📊 Table Row ${month}:`, {
    orderId: selectedPlan.order_id,
    newExpiryDate: newExpiryDate,
    formattedAdminExpiryDate: newExpiryDate ? dayjs(newExpiryDate).format("DD-MM-YYYY") : "N/A"
  });

   // Debug log for each row
  console.log(`📊 Table Row ${month} for Order ID: ${currentOrderId}`, {
    newExpiryDate: newExpiryDate,
    formattedAdminExpiryDate: newExpiryDate ? dayjs(newExpiryDate).format("DD-MM-YYYY") : "N/A"
  });

          const currentExpiry = selectedPlan.purchasedate
            ? dayjs(selectedPlan.purchasedate).add(30, "day")
            : null;

          const afterRenewalExpiry = currentExpiry
            ? currentExpiry.add(month, "month")
            : null;

          // Format Admin Expiry Date if available
          const formattedAdminExpiryDate = newExpiryDate 
            ? dayjs(newExpiryDate).format("DD-MM-YYYY") 
            : "N/A";

          return (
     <tr key={month} className="border-b hover:bg-gray-50">
      <td className="border px-4 py-2 text-center">{currentOrderId}</td>
      <td className="border px-4 py-2 text-center">
        {month} Month{month > 1 ? "s" : ""}
      </td>
      <td className="border px-4 py-2 text-center">${baseAmount.toFixed(2)}</td>
      <td className="border px-4 py-2 text-center">{selectedPlan.purchasedate || "N/A"}</td>
      <td className="border px-4 py-2 text-center">{currentExpiry ? currentExpiry.format("DD-MM-YYYY") : "N/A"}</td>
      <td className="border px-4 py-2 text-center">{afterRenewalExpiry ? afterRenewalExpiry.format("DD-MM-YYYY") : "N/A"}</td>
      <td className="border px-4 py-2 text-center">{formattedAdminExpiryDate}</td>
      <td className="border px-4 py-2 text-center">
        <button
          onClick={() => requestRenewal(selectedPlan, month)}
          className="font-bold shadow-md rounded-xl bg-brand-green-selected hover:bg-[#144745] text-brand-white px-4 py-2"
        >
          ${parseFloat((baseAmount * month).toFixed(2))} Renew
        </button>
      </td>
    </tr>
  );
})}
      </tbody>
    </table>
  ) : (
    <div className="mt-4 text-center text-green-600 font-semibold">
      <p>{renewalConfirmation.message}</p>
    </div>
  )}
</div>

    </div>
  </div>
)}



{showConfirmationModal && pendingRenewal && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
    <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
      <h1 className="text-[2rem] font-bold text-center mb-6 text-gray-800">
        Confirm Renewal
      </h1>

      <p className="text-center mb-2 text-5xl">
        Please confirm if your eSIM needs renewal for:
      </p>

      <div className="text-center font-semibold mb-6">
        <span className="text-brand-green-selected">
          {pendingRenewal.month} Month{pendingRenewal.month > 1 ? 's' : ''} -&nbsp;
          ${parseFloat(pendingRenewal.plan.purchaseamount * pendingRenewal.month).toFixed(2)}
        </span>
      </div>

      <div className="flex justify-around mt-4">
        <button
          onClick={handleRenew}
  className="font-bold self-stretch shadow-md p-4 rounded-xl bg-[#3E436D] hover:bg-[#144745] text-brand-white "
        >
          Renew
        </button>
        <button
          onClick={() => {
            setShowConfirmationModal(false);
            setPendingRenewal(null);
          }}
  className="font-bold self-stretch shadow-md p-4 rounded-xl bg-[#111f1b] hover:bg-[#144745] text-brand-white "
        >
           Cancel
        </button> 
      </div>
    </div>
  </div>
)}


    </>
  );
};

export default PurchaseReport;